import { makeStyles } from '@material-ui/core';

// Global rather than a wrapper: collectLegacyRoutes reads core.mountPoint straight off
// Route.props.element, so the Explore route element has to stay the bare routable
// extension and cannot be wrapped in anything.
//
// ToolCard hardcodes background-size: cover and ToolExplorerContent never passes its
// objectFit prop. The attribute selector is doubled on purpose: the plugin's own
// .ToolCard_media rule has equal specificity and styleInject adds it at import time, so a
// single selector loses the tie and the logos stay cropped.
//
// 32px padding lands the 64px icon files at their native size.
const useStyles = makeStyles(theme => ({
  '@global': {
    '[class*="ToolCard_media"][class*="ToolCard_media"]': {
      boxSizing: 'border-box',
      padding: 32,
      backgroundOrigin: 'content-box',
      backgroundSize: 'contain',
    },
    // GitHub only publishes a near-black mark, which disappears on the dark card. ToolCard
    // sets the image as an inline style, so the file name is the only handle on that card.
    '[class*="ToolCard_media"][style*="github.svg"]': {
      filter: theme.palette.type === 'dark' ? 'invert(1)' : 'none',
    },
  },
}));

export const ToolCardLogoStyles = () => {
  useStyles();

  return null;
};
